import React from 'react';
import { Switch, Route } from 'react-router';
import { AppRoutes, getAppRouteCacheName } from '../../../routes';
import { TimelineLocationEventDetails } from './events/TimelineLocationEventDetails';
import { TimelineLocationEvents } from './events/TimelineLocationEvents';
import { LocationDataProvider } from '../../../data/DataProviders/LocationDataProvider';
import { DataProviderCache } from '../../../data/DataProviders/DataProviderCache';
import { TimelineEventDetailDataProvider } from '../../../data/DataProviders/TimelineEventDetailDataProvider';
import { useCurrentAppRoute } from '../../../hooks/app-route-hooks';
import { DeviceDataProvider } from '../../../data/DataProviders/DeviceDataProvider';
import { OverviewSiteDeviceDetailsTabView } from '../../overview/locations/devices/OverviewDeviceDetailTabView';

export const TimelineLocation: React.FC = () => {
    const currentAppRoute = useCurrentAppRoute();

    return (
        <>
            {'locationId' in currentAppRoute && (
                <DataProviderCache for="Timeline Single Location">
                    <Switch>
                        <LocationDataProvider locationId={currentAppRoute.locationId}>
                            <Route exact path={AppRoutes.TimelineLocation} component={TimelineLocationEvents} />
                            <Route path={AppRoutes.TimelineLocationEventDetails}>
                                {'alarmId' in currentAppRoute && 'deviceId' in currentAppRoute && (
                                    <DataProviderCache for="Timeline Single Location Single Event">
                                        <TimelineEventDetailDataProvider
                                            alarmId={currentAppRoute.alarmId}
                                            deviceId={currentAppRoute.deviceId}
                                        >
                                            <DeviceDataProvider deviceId={currentAppRoute.deviceId}>
                                                <TimelineLocationEventDetails />
                                            </DeviceDataProvider>
                                        </TimelineEventDetailDataProvider>
                                    </DataProviderCache>
                                )}
                            </Route>
                            <Route exact path={AppRoutes.TimelineLocationTabDetails}>
                                    {'deviceId' in currentAppRoute && (
                                        <DataProviderCache
                                            for={getAppRouteCacheName(AppRoutes.TimelineLocationTabDetails)}                                            >
                                            <DeviceDataProvider deviceId={currentAppRoute.deviceId}>
                                                <OverviewSiteDeviceDetailsTabView />
                                            </DeviceDataProvider>
                                        </DataProviderCache>
                                    )}
                                </Route>
                        </LocationDataProvider>
                    </Switch>
                </DataProviderCache>
            )}
        </>
    );
};
